__webpack_require__.p = "https://qa.servosize.goselect.motion.abb.com/";